import { forwardRef } from "react";
import PropTypes from "prop-types";
import { useStateMachine } from "little-state-machine";
import { updateAction } from "./updateAction";
import { useVariants } from "./hooks/useVariants";
import { Carousel } from "./Carousel";
import { Form } from "./Form";
import { Spinner } from "@components/Spinner";
import styles from "./styles/section.module.css";

export const Section = forwardRef(
  ({ section, index, handleScrollTo, sections, discountMessage, isStockup, slug, width }, ref) => {
    const { isError, error, isLoading, images } = useVariants(section);
    const { actions, state } = useStateMachine({ updateAction });

    const changeProduct = (productGroup) => {
      const updatedState = {};
      updatedState[`${section.key}-productGroup`] = productGroup;
      updatedState[`${section.key}-product`] = productGroup.shopifyProducts[0];
      updatedState[`${section.key}-variant`] =
        productGroup.shopifyProducts[0].productReferenceV2.variants[0];
      actions.updateAction(updatedState);
    };

    if (isLoading) {
      return (
        <section className={styles.loading}>
          <Spinner />
        </section>
      );
    }

    if (isError) {
      return <section className={styles.loading}>Something went wrong {error}</section>;
    }

    return (
      <div className={styles.section} ref={ref}>
        {state[`${section.key}-productGroup`] && (
          <>
            <Carousel
              images={images}
              changeProduct={changeProduct}
              width={width}
              currentProductGroupID={state[`${section.key}-productGroup`]._id}
            />

            <Form
              section={section}
              sections={sections}
              index={index}
              handleScrollTo={handleScrollTo}
              discountMessage={discountMessage}
              isStockup={isStockup}
              slug={slug}
            />
          </>
        )}
      </div>
    );
  }
);

Section.propTypes = {};
